import { render, staticRenderFns } from "./SystemMessage.vue?vue&type=template&id=7ed654dc&scoped=true&"
import script from "./SystemMessage.vue?vue&type=script&lang=js&"
export * from "./SystemMessage.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SystemMessage.vue?vue&type=style&index=0&id=7ed654dc&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7ed654dc",
  null
  ,true
)

export default component.exports